import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { usePriceComponents } from "@/components/Sections/Price/hooks/usePriceComponents";
import { ComponentWrapper } from "@/components/Sections/Price/DefaultView/ComponentWrapper";
import { Divider } from "@gemini/ui";
import { PriceUnit } from "@/components/Sections/Price/DefaultView/PriceUnit";
import { Box } from "@gemini/core";
export const PriceComponents = () => {
    var _a;
    const components = (_a = usePriceComponents()) !== null && _a !== void 0 ? _a : [];
    return (_jsx(_Fragment, { children: components.map(({ key, type, units }, index) => (_jsx(ComponentWrapper, { type: type, marginTop: index > 0 ? "spacing.32" : "spacing.none", isLast: index === components.length - 1, children: units.map((unit, unitIndex) => (_jsxs(Box, { children: [unitIndex > 0 && (_jsx(Divider, { marginVertical: "spacing.16", "aria-hidden": "true" })), _jsx(PriceUnit, { unit: unit })] }, unit.key))) }, key))) }));
};
